import PropTypes from 'prop-types';
import * as RequestStatusTypes from './RequestStatusTypes';
import AllTemplateTypes from 'ContentUtils/constants/TemplateTypes';
const {
  byName: TemplateTypes
} = AllTemplateTypes;
export const EMBED_IFRAME_APP_NAME = 'theme-iframe-ui';
export const EMBED_SCRIPT_PATH = 'bundles/embed.js';
export const ENVIRO_SERVICE_NAME = 'theme-previewer';
export const DebugOptions = Object.freeze({
  HIGHLIGHT_FIELD_SELECTORS: 'highlightFieldSelectors',
  PREVIEW_DEVICES: 'previewDevices',
  JAVASCRIPT_INTEGRATION: 'javascriptIntegration'
});
export const DEBUG_OPTION_KEYS = Object.values(DebugOptions || {});
export const CustomPropTypes = Object.freeze({
  debugOptions: PropTypes.shape({
    [DebugOptions.HIGHLIGHT_FIELD_SELECTORS]: PropTypes.bool,
    [DebugOptions.PREVIEW_DEVICES]: PropTypes.bool
  }),
  requestStatus: PropTypes.oneOf(Object.keys(RequestStatusTypes)),
  templateType: PropTypes.oneOf(Object.keys(TemplateTypes).map(key => TemplateTypes[key].id))
});
export const TEMPLATE_REFRESH_DOM_TAG_NAME = 'BODY';
export const INLINED_STYLES_ATTRIBUTE = 'data-hs-source';
export const CHANGE_HISTORY_LIMIT = 100;
export const ROOT_GROUP_FIELD_KEY = [];
export const APP_CONTEXTS = Object.freeze({
  SETTINGS: 'settings',
  PAGE_EDITOR: 'pageEditor',
  DESIGN_MANAGER: 'designManager',
  CONTENT_CREATOR: 'contentCreator',
  BRANDING_SETTINGS: 'brandingSettings',
  MARKETPLACE_DOWLOADS: 'marketplaceDownloads'
});
export const UNIVERSAL_THEME_EDITING_APPS = {
  PAGE_EDITOR: 'pageEditor'
};
export const CREATE_CONTENT_TYPES = Object.freeze({
  BLOG: 'blog',
  LANDING_PAGE: 'landing-page',
  SITE_PAGE: 'site-page'
});
export const PORTALS_HOT_RELOAD_RECEIVED_TIMEOUT = 2000;
export const PORTALS_READY_SIGNAL_TIMEOUT = 5000;